import { StoreRootState } from '@/store';
import { personaHomePage } from '@/utils/constants';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { Roles } from '@/utils/types';

const AuthGuard = ({ redirectTo = '/', allowedRoles = ['*'] }: { redirectTo: string; allowedRoles?: Roles[] | ['*'] }) => {
	const navigate = useNavigate();
	const { user } = useSelector((state: StoreRootState) => state.auth);
	useEffect(() => {
		if (!user) navigate(redirectTo);
	}, [user]);
	return allowedRoles[0] === '*' ||
		allowedRoles.find((r) => r.toLocaleLowerCase() === user?.role.toLocaleLowerCase()) ? (
		<Outlet />
	) : (
		<>
			<Navigate to={personaHomePage[user?.role]} />
		</>
	);
};

export default AuthGuard;
